import * as z from 'zod';

const PASSWORD_PATTERN = /^[\dA-Za-z]+$/;
export const passwordSchema = z.string().min(8).max(16).regex(PASSWORD_PATTERN, '英数字で入力して下さい');
